import React from 'react'
import { Grid } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { InputCorreo, InputTexto } from '../../comp/Input'
import { InputFecha } from '../../comp/InputFecha'
import { FiltroEstadoActivo } from '../../comp/FiltroEstadoActivo'
import { ModalDetail } from '../../comp/ModalDetail'
import { ModalSearch } from '../../comp/ModalSearch'
import { Normal } from '../../comp/Texto'
import { TooltipButton } from '../../comp/TooltipButton'
import { Traduccion } from '../../comp/Traduccion'
import { DataTable } from '../../comp/DataTableSimple'
import { TipoDato } from '../../utils/Constantes'
import { listarTransacciones } from '../../services/servClientes'
import { Acciones } from '../../utils/Acciones'
import { agregarUsuario, listarRoles, modificarUsuario } from '../../services/servUsuarios'
import { Messages } from '../../comp/Messages2'
import { InputSelect } from '../../comp/InputSelect'
import { Info } from '../../comp/Message'

export const Filtros = ({ filtros, isOpen, onSubmit }) => {

    const [form, setForm] = React.useState(filtros)

    const modalSearchMaxWidth = 300

    const handleFormChange = (val, field) => setForm({...form, [field]: val})
    const handleSubmit = (res) => onSubmit(res, form)

    React.useEffect(() => { if (isOpen) setForm(filtros) }, [filtros, isOpen])

    return (<ModalSearch isOpen={isOpen} onSubmit={handleSubmit}>
        <Grid container spacing={2} style={{ maxWidth: modalSearchMaxWidth }}>
            <Grid item xs={12}>
                <InputTexto id='nombres_usuarios'
                    label={Traduccion('TXT_NOMBRE')}
                    value={form.nombres}
                    onChange={v => handleFormChange(v, 'nombres')}
                    autoFocus />
            </Grid>
            <Grid item xs={12}>
                <InputTexto id='apellidos_usuarios'
                    label={Traduccion('TXT_APELLIDO')}
                    value={form.apellidos}
                    onChange={v => handleFormChange(v, 'apellidos')} />
            </Grid>
            <Grid item xs={12}>
                <FiltroEstadoActivo id='estado_activo_usuario'
                    value={form.activo}
                    onChange={v => handleFormChange(v, 'activo')} />
            </Grid>
        </Grid>
    </ModalSearch>)
}

const FORM_STATUS = {
    ready: Symbol(),
    submitted: Symbol(),
    submitting: Symbol()
}

const dominiosValidos = Object.freeze(['gmail.com', 'hotmail.com', 'hotmail.com.ar', 'yahoo.com', 'yahoo.com.ar', 'outlook.com', 'outlook.com.ar', 'icloud.com', 'live.com', 'live.com.ar'])

export const Detalle = ({ seleccion, accion, isOpen, onSubmit }) => {

    const [form, setForm] = React.useState({activo:true})
    const [formStatus, setFormStatus] = React.useState(FORM_STATUS.ready)

    const handleFormChange = (val, field) => setForm({...form, [field]: val})
    const handleRolChange = (val, field) => setForm({
        ...form, [field]: rolesActivos.filter(r => val.includes(r.id))
    })

    const [rolesActivos, setRolesActivos] = React.useState([])
    const formatRoles = () => rolesActivos.map(e => ({ label: e.nombre, value: e.id }))

    const [resServicio, setResServicio] = React.useState()

    const obligatoriosConValor = () => (form.apellidos && form.nombres && (accion === Acciones().ADD ? form.email : true) && form.roles?.length)
    const emailConDominioValido = () => dominiosValidos.includes(form.email?.split('@')[1])

    const handleSubmit = async (res) => {
        let datosFormulario = {...form}
        if (!res) return onSubmit()
        if (res && !obligatoriosConValor()) return setFormStatus(FORM_STATUS.submitted)
        if (res && accion === Acciones().ADD && !emailConDominioValido()) return setFormStatus(FORM_STATUS.submitted)
        setFormStatus(FORM_STATUS.submitting)
        let resServ = (accion === Acciones().ADD)
            ? await agregarUsuario(form)
            : await modificarUsuario(form)
        setResServicio(resServ)
        if (resServ.errores) {
            if (!resServ.errores.includes('ERR_USUARIO_EMAIL_UK')) return setFormStatus(FORM_STATUS.submitted)
            datosFormulario.apellidos = resServ.data.apellidos
            datosFormulario.nombres = resServ.data.nombres
        }
        if (!datosFormulario.id) datosFormulario.id = resServ.data.id
        onSubmit(datosFormulario)
    }

    //inicializo el componente
    React.useEffect(() => {
        listarRoles({ activo: true }).then(res => {
            if (res.errores) setResServicio(res)
            else setRolesActivos(res.data)
        })
    },[])

    React.useEffect(() => {
        if (isOpen) {
            setForm(seleccion ?? {activo: true})
            setFormStatus(FORM_STATUS.ready)
            setResServicio()
        }
    }, [seleccion, isOpen])
    
    //inicializo los msjs cada vez que cierro el modal
    React.useEffect(() => {
        if (!isOpen) setResServicio()
    }, [isOpen])

    return <>
        <ModalDetail accion={accion} isOpen={isOpen} onSubmit={handleSubmit}
            isLoading={formStatus === FORM_STATUS.submitting}
            >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <InputTexto id='apellidos'
                        label={Traduccion('TXT_APELLIDOS')}
                        value={form.apellidos}
                        onChange={v => handleFormChange(v, 'apellidos')}
                        validarSubmit={formStatus === FORM_STATUS.submitted}
                        maxLength={30}
                        autoFocus requerido/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputTexto  id='nombres'
                        label={Traduccion('TXT_NOMBRES')}
                        value={form.nombres}
                        onChange={v => handleFormChange(v, 'nombres')}
                        validarSubmit={formStatus === FORM_STATUS.submitted}
                        maxLength={30}
                        requerido />
                </Grid>
                <Grid item xs={12}>
                    <InputCorreo id='email'
                        label={Traduccion('TXT_CORREO')}
                        value={form.email}
                        onChange={handleFormChange}
                        validarSubmit={formStatus === FORM_STATUS.submitted}
                        editable={accion === Acciones().ADD}
                        dominiosValidos={dominiosValidos}
                        maxLength={50}
                        requerido />
                </Grid>
                <Grid item xs={12}>
                    <InputSelect id='roles'
                        label={Traduccion('TXT_ROLES')}
                        value={form.roles?.map(r => r.id) ?? []}
                        onChange={v => handleRolChange(v, 'roles')}
                        validarSubmit={formStatus === FORM_STATUS.submitted}
                        isLoading={!rolesActivos.length}
                        options={formatRoles()}
                        multiple requerido />
                </Grid>
            { accion === Acciones().ADD &&
                <Grid item xs={12}>
                    <Info>{Traduccion('INFO_ENVIO_CREDENCIALES_MAIL')}</Info>
                </Grid>
            }
            </Grid>
        </ModalDetail>
        <Messages resServicio={resServicio} accion={accion} />
    </>
}

export const ModalConexiones = ({ seleccion = {}, isOpen, onSubmit }) => {

    const tableConfig = {
        headers: ['TXT_FECHA', 'TXT_TIPO_TRANSACCION', 'TXT_IMPORTE', 'TXT_SALDO'],
        types: [TipoDato.FECHA, TipoDato.CADENA, TipoDato.IMPORTE, TipoDato.IMPORTE],
        access: ['fecha', 'detalle', 'importe', 'saldo']
    }

    const [isTableLoading, setIsTableLoading] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const [tableFilters, setTableFilters] = React.useState({
        fechaDesde: null,
        fechaHasta: null,
        pageNumber: 0,
        pageSize: 10,
        clienteId: seleccion.id
    })

    const setFechaDesde = (fecha) => {
        let aux = { ...tableFilters }
        aux.fechaDesde = fecha
        aux.pageNumber = 0
        setTableFilters(aux)
    }

    const setFechaHasta = (fecha) => {
        let aux = { ...tableFilters }
        aux.fechaHasta = fecha
        aux.pageNumber = 0
        setTableFilters(aux)
    }

    const pagSiguiente = () => {
        let aux = { ...tableFilters }
        aux.pageNumber += 1
        setTableFilters(aux)
    }

    const pagAnterior = () => {
        let aux = { ...tableFilters }
        aux.pageNumber -= 1
        setTableFilters(aux)
    }

    const formatDataForTable = (datos) => {
        datos.forEach(d => {
            d.detalle = Traduccion(d.tipoTransaccion.nombre)
        })
        return //agregar funcionalidad si hace falta
    }

    React.useEffect(() => {
        if (isOpen) {
            setTableFilters({
                fechaDesde: null,
                fechaHasta: null,
                pageNumber: 0,
                pageSize: 10,
                clienteId: seleccion.id
            })
        }
    }, [seleccion, isOpen])

    React.useEffect(() => {
        if (tableFilters.clienteId) {
            setIsTableLoading(true)
            listarTransacciones(tableFilters).then(res => {
                formatDataForTable(res.data)
                setTableData(res.data)
                setIsTableLoading(false)
            })
        }
    }, [tableFilters])

    return <ModalDetail isOpen={isOpen} onSubmit={onSubmit} accion={Acciones().SEE} customTitle='TXT_TRANSACCIONES' maxWidth='md'>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <InputFecha label={Traduccion('TXT_FECHA_DESDE')}
                    value={tableFilters.fechaDesde}
                    onChange={fecha => setFechaDesde(fecha)} />
            </Grid>
            <Grid item xs={6}>
                <InputFecha label={Traduccion('TXT_FECHA_HASTA')}
                    value={tableFilters.fechaHasta}
                    onChange={fecha => setFechaHasta(fecha)} />
            </Grid>
            <Grid item xs={12}>
                <DataTable headers={tableConfig.headers}
                    types={tableConfig.types}
                    access={tableConfig.access}
                    data={tableData}
                    isLoading={isTableLoading}
                    size='small' />
            </Grid><Grid container justifyContent='center' alignItems='center'>
                <Grid item>
                    <TooltipButton label="TXT_ANTERIOR"
                        onClick={pagAnterior}
                        disabled={tableFilters.pageNumber === 0}>
                        <KeyboardArrowLeftIcon />
                    </TooltipButton>
                </Grid>
                <Grid item>
                    <Normal>{Traduccion('TXT_PAGINA_ABREV')}: {tableFilters.pageNumber + 1}</Normal>
                </Grid>
                <Grid item>
                    <TooltipButton label="TXT_SIGUIENTE"
                        onClick={pagSiguiente}
                        disabled={tableData.length < tableFilters.pageSize}>
                        <KeyboardArrowRightIcon />
                    </TooltipButton>
                </Grid>
            </Grid>
        </Grid>

    </ModalDetail>

}